/**
 * pages/news-archive.js — Νέα/Άρθρα/Δελτία Τύπου archive / category grid
 *
 * Same progressive-enhancement pattern as pages/erga-archive.js: filter
 * and pagination links (.js-news-nav) are real, cacheable URLs (blog home
 * / category archives). Clicking one fetches that same URL, swaps in
 * #news-results (+ #news-filters, so "active" styling always matches the
 * server-rendered state), shows a skeleton while loading, and keeps the
 * address bar in sync via history.pushState/popstate. Works with JS
 * disabled too — links are just normal navigation then.
 */

(function () {
    var resultsEl  = document.getElementById('news-results');
    var skeletonEl = document.getElementById('news-skeleton');
    var filtersEl  = document.getElementById('news-filters');

    if (!resultsEl) {
        return;
    }

    function loadUrl(url) {
        if (skeletonEl) {
            skeletonEl.classList.remove('hidden');
        }
        resultsEl.classList.add('hidden');

        fetch(url)
            .then(function (res) {
                return res.text();
            })
            .then(function (html) {
                var doc        = new DOMParser().parseFromString(html, 'text/html');
                var newResults = doc.getElementById('news-results');
                var newFilters = doc.getElementById('news-filters');

                if (newResults) {
                    resultsEl.innerHTML = newResults.innerHTML;
                }

                if (newFilters && filtersEl) {
                    filtersEl.innerHTML = newFilters.innerHTML;
                }

                if (doc.title) {
                    document.title = doc.title;
                }

                resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
            })
            .catch(function () {
                window.location.href = url;
            })
            .finally(function () {
                if (skeletonEl) {
                    skeletonEl.classList.add('hidden');
                }
                resultsEl.classList.remove('hidden');
            });
    }

    document.addEventListener('click', function (e) {
        var link = e.target.closest('.js-news-nav');
        if (!link) {
            return;
        }

        e.preventDefault();
        var url = link.getAttribute('href');
        window.history.pushState({ newsUrl: url }, '', url);
        loadUrl(url);
    });

    window.addEventListener('popstate', function () {
        loadUrl(window.location.href);
    });
})();
